import type { Comment } from "@/api/http/schemas/commentsSchema";

const renderCommentAsPlainText = (comment: Comment) => {
  const content = comment.content?.items;

  if (!content) {
    return "";
  }

  const textContent = content.filter((item) => item.type === "text").map((item) => item.text);
  const asText = textContent.join(" ");

  return asText;
};

export { renderCommentAsPlainText };
